/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckPartnerActiveOpportunityByOtherUser200Response
 */
export interface CheckPartnerActiveOpportunityByOtherUser200Response {
    /**
     * 
     * @type {boolean}
     * @memberof CheckPartnerActiveOpportunityByOtherUser200Response
     */
    hasActiveOpportunity?: boolean;
}

/**
 * Check if a given object implements the CheckPartnerActiveOpportunityByOtherUser200Response interface.
 */
export function instanceOfCheckPartnerActiveOpportunityByOtherUser200Response(value: object): value is CheckPartnerActiveOpportunityByOtherUser200Response {
    return true;
}

export function CheckPartnerActiveOpportunityByOtherUser200ResponseFromJSON(json: any): CheckPartnerActiveOpportunityByOtherUser200Response {
    return CheckPartnerActiveOpportunityByOtherUser200ResponseFromJSONTyped(json, false);
}

export function CheckPartnerActiveOpportunityByOtherUser200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckPartnerActiveOpportunityByOtherUser200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'hasActiveOpportunity': json['hasActiveOpportunity'] == null ? undefined : json['hasActiveOpportunity'],
    };
}

export function CheckPartnerActiveOpportunityByOtherUser200ResponseToJSON(json: any): CheckPartnerActiveOpportunityByOtherUser200Response {
    return CheckPartnerActiveOpportunityByOtherUser200ResponseToJSONTyped(json, false);
}

export function CheckPartnerActiveOpportunityByOtherUser200ResponseToJSONTyped(value?: CheckPartnerActiveOpportunityByOtherUser200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasActiveOpportunity': value['hasActiveOpportunity'],
    };
}

